import React from 'react';
import {Redirect, Link} from 'react-router-dom';
import {Card, Image} from 'semantic-ui-react';
import {observer, inject} from 'mobx-react'
import Button from 'react-bulma-components/lib/components/button';
import ArtworkDetail from '../products/artworkDetailsModal'
import {func} from 'prop-types';
import {toast} from 'react-toastify';
import Modal from "react-bulma-components/lib/components/modal";
// import Button from "react-bulma-components/lib/components/button";
import Section from "react-bulma-components/lib/components/section";
// import { inject, observer } from "mobx-react";
import OpenConfModal from '../errorHandling/errorModal'

var addMenu;

@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'likeAndUnlikeStore', 'requestsStore')
@observer
export default class artworksCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            clickedOnArtwork: false,
            clickedOnArtist: false,
            clickedArtistId: false,
            openArtworkModal: false
        }
    }


    componentWillMount() {
        // addMenu = new nw.Menu();
        // addMenu.append(new nw.MenuItem({
        //     label: 'doSomething',
        //     click: function() {
        //         // doSomething
        //     }
        // }));
    }


    handleArtworkClick(e, item) {
        var hrefLocation = `${window.location.href}`
        // console.log("clicked on artist contextmenu")
        if (hrefLocation.includes("myprofile") || hrefLocation.includes("profile/details")) {
            // console.log("should go open tab")
            this.setState({
                clickedOnArtwork: true,
                clickedArtworkId: item.artwork.url_slug
            }, function () {
                // console.log("should contextmenu", this.state.clickedOnArtwork)
            })

        } else if (e.type === "click") {
            e.preventDefault();
            this.setState({
                    clickedOnArtwork: true,
                    clickedArtworkId: item.artwork.url_slug
                }
                , function () {
                    // console.log("[mounted]", this.state.openArtworkModal)
                })
            // this.props.navigatorStore.openArtworkDetailsModal();
            // console.log("contextmenu,do something else")
        }
        // addMenu.popup(e.clientX, e.clientY);
        else {
            // e.preventDefault();
            // console.log("contextmenu, should not come here")
            // this.setState({
            //     clickedOnArtwork: true,
            //     clickedArtworkId: item
            // })
        }
    }


    handleArtistClickInArtworkCard(item) {


        // else {
        // console.log("clicked on artist", item)
        this.setState({
            clickedOnArtist: true,
            clickedArtistId: item
        }, function () {
            // console.log(this.state.clickedArtistId)
        })
        // }
    }

    resetClickedOnArtwork() {
        this.setState({
            clickedOnArtwork: false
        })
    }

    resetClickedOnArtist() {
        this.setState({
            clickedOnArtist: false
        })
    }

    // handleLikeArtworkClick(id, liked) {

    // }
    render() {

        if (this.state.clickedOnArtwork) {
            // console.log("should redirect to product details")
            // return (
            window.open(`/product/details/${this.state.clickedArtworkId}`, '_blank')
            //    window.open(`/product/details/${this.state.clickedArtworkId}` , '_blank')
            this.resetClickedOnArtwork()
            // )
            // return (
            //     <Redirect push to={{ pathname: `/product/details/${this.state.clickedArtworkId}` }} />
            // )
        }

        if (this.state.clickedOnArtist) {
            // return (
            window.open(`/profile/details/${this.state.clickedArtistId}`)
            this.resetClickedOnArtist()
            // )
        }
        return (
            // <div className="row">
            // {this.state.openModal && <ArtworkDetail details={this.state.openArtworkModal}></ArtworkDetail>}
            <ArtworksCardHolder
                artworkData={this.props.artworkData}
                handleArtistClickInArtworkCard={this.handleArtistClickInArtworkCard.bind(this)}
                handleArtworkClick={this.handleArtworkClick.bind(this)}
                clickedOnArtwork={this.state.clickedOnArtwork}
            />
            // </div>
        )
    }


}

@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'likeAndUnlikeStore', 'requestsStore')
@observer
class ArtworksCardHolder extends React.Component {
    // debugger;
    constructor(props) {
        super(props)
        props = this.props;
        let likedMap = this.initializeFreshState(props);
        this.state = likedMap;
    }

    componentDidMount() {
        let likedMap = this.initializeFreshState(this.props);
        this.setState(likedMap);
    }

    componentWillReceiveProps(nextProps) {
        let likedMap = this.initializeFreshState(nextProps);
        this.setState(likedMap);
    }

    initializeFreshState(props) {
        // console.log("artworkData looks like", props.artworkData)
        let likeMap = {};
        if (!!props.artworkData && !!props.artworkData.length) {
            props.artworkData.forEach((el) => {

                // console.log("EL looks like", el)
                likeMap[el.artwork.id] = {liked: el.liked, count: el.artwork.total_likes_received};
            });
        }
        // console.log("artworkData looks like", props.artworkData)
        // console.log("likeMap looks like", likeMap)
        return likeMap;
    }

    handleLikeArtworkClick(id) {

        if (!localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal();
            return;
        } else {
            // console.log("ID looks like", id);
            let item = this.state[id];
            // console.log("ID looks like", item);

            if (item && !item.liked) {
                this.setState({
                    likeInProcess: true,
                    [id]: {liked: !item.liked, count: item.count + (!item.liked ? 1 : -1)},
                }, () => {
                    toast((item.liked) ? "This artwork was removed from your collection!" : "This artwork was added to your collection!");
                    this.props.likeAndUnlikeStore[item.liked ? 'unLikeTheArtwork' : 'likeTheArtwork'](id)
                        .then(() => {
                            this.setState({
                                likeInProcess: false
                            }, () => {
                                // console.log("successfully unliked/liked", !item.liked)
                            })
                        })
                })
            } else {
                // this.props.navigatorStore.openErrorModal("Are you sure you want to remove this artwork from your collection?", true, id)
                this.setState({
                    errorModal: true,
                    artworkToLike: id
                })
            }
        }
    }

    close() {
        this.setState({
            errorModal: false,
            artworkToLike: null
        })
    }

    figuredOutMediumAndBase(stringToEdit) {
        if (!!stringToEdit) {
            var removedOthers = stringToEdit.replace(", Others", "");
            removedOthers = removedOthers.replace("Others ,", "");
            removedOthers = removedOthers.replace("Others", "");
            var removedComma = removedOthers.replace(", ,", ",");
            // console.log("got it stringToEdit",
            // {stringToEdit:stringToEdit,removedComma:removedComma,removedOthers:removedOthers})
            if (removedComma.charAt(0) == ",") {
                removedComma = removedComma.substr(1, removedComma.length)
            }
        }
        return removedComma
    }

    handleConfirmModalAction(e, actionInfo) {

        let id = this.state.artworkToLike;
        let item = this.state[id];
        // console.log("handling modal action ", item);
        this.close();
        actionInfo ?
            this.setState({
                [id]: {liked: !item.liked, count: item.count + (!item.liked ? 1 : -1)},
                likeInProcess: true
            }, () => {
                this.props.likeAndUnlikeStore.unLikeTheArtwork(id)
                    .then((res) => {
                        // console.log(res)
                        this.props.artworksStore.getArtworkDetailsPublicAuth(id, null, true)
                            .then((resp) => {
                                toast("This artwork was removed from your collection!")
                                // console.log("this is artwork data", resp);
                                this.setState({
                                    likeInProcess: false,
                                    // actualLiked: resp.data.data[0].artwork.liked,
                                    // likes_received: resp.data.data[0].artwork.total_likes_received,
                                }, function () {
                                    // console.log(resp, this.state.artworkData)
                                })
                            })
                            .catch((err) => {
                                // console.log(err);
                                return
                            })
                    })
            })
            : ""
    }

    render() {
        return (
            <div className="row">
                <Modal show={this.state.errorModal} onClose={this.close.bind(this)}
                       className="error-modal-layout"
                >
                    {/* {this.props.children} */}
                    <Modal.Content>
                        <Section style={{backgroundColor: 'white', padding: "none"}} className="mymodal">
                            <form className="myform">
                                {/* <div style={{ textAlign: "left" }} className="log-in">
                                            <div className="ruling-forgot-password-section"></div> */}


                                <p className="error-text pl-25 ml-15 mt-25">
                                    <img onClick={this.close.bind(this)} className="cross-icon-for-masterpieces-modal"
                                         src={require('../../assets/cross_icon_for_close.png')}></img>


                                    Are you sure you want to remove this artwork from your collection? <br/>
                                </p>

                                <div className="remember-me-and-login-section error-btn-block">

                                    <div style={{
                                        flex: "1",

                                    }}>
                                        <Button className="button-link-login width-110"
                                                onClick={(e) => this.handleConfirmModalAction(e, false)}
                                                style={{
                                                    backgroundColor: "#BEA57C",
                                                    borderRadius: "unset",
                                                    marginRight: "10px"
                                                }}>
                                            {"NO"}
                                        </Button>
                                        <Button className="button-link-login width-110"
                                                onClick={(e) => this.handleConfirmModalAction(e, true)} style={{
                                            backgroundColor: "#333333",
                                            borderRadius: "unset", marginRight: "10px",
                                        }}>YES
                                        </Button>
                                    </div>

                                </div>


                            </form>
                        </Section>
                    </Modal.Content>
                </Modal>

                {
                    (this.props.artworkData && this.props.artworkData.length && !!this.props.artworkData[0].artwork && this.props.artworkData[0].artwork)
                        ? this.props.artworkData.map((el, elIndex) =>
                            <div key={elIndex} className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-3">
                                <Card className="artwork-card" style={{position: "relative"}} key={elIndex}>
                                    {/* <a
                                        target='_blank'
                                        href={`/product/details/${el.artwork.url_slug}`}> */}
                                    <Image onClick={(e) => this.props.handleArtworkClick(e, el)} className="artworks-image"
                                           src={el.artwork.timg1 || el.artwork.img1 || require('../../assets/artwork_image.png')}/>
                                    {/* </a> */}
                                    <div className="artworks-likes-rectangle"
                                         onClick={!this.state.likeInProcess ? () => this.handleLikeArtworkClick(el.artwork.id) : () => {
                                         }}
                                    ><img className="heart-icon-for-painting-likes"
                                          src={(this.state[el.artwork.id].liked) ? require('../../assets/heart_icon.png') : require('../../assets/heart_icon_outline.png')}></img>{this.state[el.artwork.id].count}
                                    </div>
                                    {/* <OpenConfModal handleActions={this.handleConfirmModalAction.bind(this)} /> */}
                                    <Card.Content className="rectangle-card-description">
                                        <Card.Description className="artwork-description-block">
                                            {/* <div onClick={() => this.props.handleArtistClickInArtworkCard(el.artwork.user_profile[(!!el.artwork.user_profile.display_name) ? "display_name" : "old_display_name"]  )} className="artist-image-block"> */}
                                            {/* <a
                                                target='_blank'
                                                href={`/profile/details/${el.artwork.user_profile.share_url.substr(el.artwork.user_profile.share_url.lastIndexOf("/") + 1)}`}> */}
                                            <div className="artist-image-block">
                                                <img alt="" className="artist-image"
                                                     onClick={(e) => this.props.handleArtistClickInArtworkCard(el.artwork.user_profile.share_url.substr(el.artwork.user_profile.share_url.lastIndexOf("/") + 1))}
                                                     src={(el.artwork.user_profile) ? el.artwork.user_profile.timg || el.artwork.user_profile.image || (el.artwork.user_profile.fb_id &&
                                                         `https://graph.facebook.com/${el.artwork.user_profile.fb_id}/picture?type=large`)
                                                         || require('../../assets/default_picture.png') : ""}></img>
                                            </div>
                                            {/* </a> */}
                                            {/* < a
                                                target='_blank'
                                                href={el.artwork.user_profile.share_url}> */}
                                            <div className="artwork-data"
                                                 onClick={(e) => this.props.handleArtworkClick(e, el)}>
                                                <p className="artwork-name">{(el.artwork.title) ? el.artwork.title : el.artwork.old_title}</p>
                                                <p className="artist-artwork-technique">    {
                                                    (el.artwork.base) ? this.figuredOutMediumAndBase(el.artwork.medium)
                                                        : el.artwork.medium
                                                }{
                                                    (!!el.artwork.custom_medium) ? !!this.figuredOutMediumAndBase(el.artwork.medium) ? `, ${el.artwork.custom_medium}` : ` ${el.artwork.custom_medium}` : ""
                                                }</p>
                                            </div>
                                            {/* </ a> */}
                                            <div className="arrow-block">
                                                {/* <a
                                                    target='_blank'
                                                    href={`/product/details/${el.artwork.id}`}> */}
                                                <img
                                                    onClick={(e) => this.props.handleArtworkClick(e, el)}
                                                    alt="" className="artwork-arrow"
                                                    src={require('../../assets/arrow_svg.svg')}></img>
                                                {/* </a> */}
                                            </div>

                                        </Card.Description>
                                    </Card.Content>
                                </Card>
                            </div>
                        )
                        : ""
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/cardHolders/artworksCard.js